export default "/assets/images/accessory-img-03.jpg?f9c60db82418c39da8705c67d1f34fa2";